import { useEffect, useState } from 'react';
import styles from './HeaderMaster.module.css';
import foto_soraia from "../../../images/sosofotinha.png";

const DIAS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

function formatarRelogio(data) {
    const dia = DIAS[data.getDay()];
    const dataFmt = data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    const horaFmt = data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    return `${dia} ${dataFmt}  ${horaFmt}`;
}

// Barra superior enxuta: um relógio vivo (o console está sempre monitorando
// algo em tempo real, então ele mesmo precisa parecer "ao vivo") e a
// identidade de quem está logado. Sem banner decorativo nem subtítulo
// repetido em toda página — o título de cada seção já diz onde você está.
function HeaderMaster() {
    const nomeMaster = localStorage.getItem("nome_usuario") || "Master";
    const [agora, setAgora] = useState(() => new Date());

    useEffect(() => {
        const intervalo = setInterval(() => setAgora(new Date()), 1000);
        return () => clearInterval(intervalo);
    }, []);

    return (
        <header className={styles.header_master}>
            <span className={styles.relogio}>{formatarRelogio(agora)}</span>

            <div className={styles.perfil_area}>
                <span className={styles.nomeMaster}>{nomeMaster}</span>
                <img src={foto_soraia} alt="" />
            </div>
        </header>
    );
}

export default HeaderMaster;
